<template>
  <div class="w-full">
    <templates-picker
      v-if="!selectedWaTemplate"
      :inbox-id="inboxId"
      :template-filter="templateFilter"
      :empty-state="emptyState"
      @onSelect="pickTemplate"
      @create-template="$emit('create-template')"
    />
    <template-parser
      v-else
      ref="parser"
      :template="selectedWaTemplate"
      :show-actions="showActions"
      @resetTemplate="onResetTemplate"
      @sendMessage="onSendMessage"
    />
  </div>
</template>

<script>
import TemplatesPicker from './OnlineWaTemplatesPicker.vue';
import TemplateParser from './OnlineWaTemplateParser.vue';
export default {
  components: {
    TemplatesPicker,
    TemplateParser,
  },
  props: {
    inboxId: {
      type: Number,
      default: undefined,
    },
    show: {
      type: Boolean,
      default: true,
    },
    showActions: {
      type: Boolean,
      default: true,
    },
    templateFilter: {
      type: Function,
      default: null,
    },
    emptyState: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      selectedWaTemplate: null,
    };
  },
  watch: {
    inboxId() {
      this.selectedWaTemplate = null;
    },
  },
  methods: {
    pickTemplate(template) {
      this.$emit('pickTemplate', true);
      this.selectedWaTemplate = template;
    },
    onResetTemplate() {
      this.$emit('pickTemplate', false);
      this.selectedWaTemplate = null;
    },
    onSendMessage(message) {
      this.$emit('on-send', message);
    },
    send() {
      this.$refs.parser?.sendMessage();
    },
    onClose() {
      this.$emit('cancel');
    },
  },
};
</script>

<style></style>
